import { render, staticRenderFns } from "./BounceDetailsPage.vue?vue&type=template&id=c6f81d4c&scoped=true"
import script from "./BounceDetailsPage.vue?vue&type=script&lang=js"
export * from "./BounceDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BounceDetailsPage.vue?vue&type=style&index=0&id=c6f81d4c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f81d4c",
  null
  
)

export default component.exports